import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, UntypedFormBuilder } from '@angular/forms';
import {UserService} from '../../services/user/user.service';
import {takeWhile} from 'rxjs';
import {BehaviorSubject} from 'rxjs';
import {User} from '../../services/user/user';


@Component({
    selector: 'app-user-pref-head',
    templateUrl: './user-pref-head.component.html',
    styleUrls: ['./user-pref-head.component.css'],
    standalone: false
})
export class UserPrefHeadComponent implements OnInit, OnDestroy {
  showBody:any;
  screenName : any;
  userPreferencesHeadForm: UntypedFormGroup;
  listOptions: any = {};
  private observer$ = new BehaviorSubject(true);
  currentUser: User;

  constructor(private fb: UntypedFormBuilder, private userService: UserService) { }

  ngOnInit(): void {
    this.userService.getCurrentUserObservable()
        .pipe(takeWhile(() => this.observer$.value)).subscribe(currentUser => {
      this.currentUser = currentUser;
      if(this.currentUser.permissions === "HHG & FRT"){
        this.updateListOPtions(1);
      }else if(this.currentUser.permissions === "HHG"){
        this.updateListOPtions(2);
      }else if(this.currentUser.permissions === "FRT"){
        this.updateListOPtions(3);
      }else{
        this.updateListOPtions(4);
      }
    }, (error) => {
      console.log("ERROR: error when retrieving permission for user");
    });

    this.userPreferencesHeadForm = this.fb.group({
      screenName: new UntypedFormControl(null),
    });
    this.showBody = false;
  }

  updateListOPtions(permission: number){
    switch(permission){
      case 1:
        this.listOptions = [
          {
            name: "HHG Query Preferences",
            value: "HHGResults"
          },
          {
            name: "HHG Query Extended Storage Preferences",
            value: "HHGExtResults"
          },
          {
            name: "HHG Shipments",
            value: "HHGShipments"
          },
          {
            name: "FRT Query Preferences",
            value: "FRTResults"
          },
          {
            name: "FRT Shipments",
            value: "FRTShipments"
          }
        ];
        break;
      case 2:
        this.listOptions = [
          {
            name: "HHG Query Preferences",
            value: "HHGResults"
          },
          {
            name: "HHG Query Extended Storage Preferences",
            value: "HHGExtResults"
          },
          {
            name: "HHG Shipments",
            value: "HHGShipments"
          }
        ];
        break;
      case 3:
        this.listOptions = [
          {
            name: "FRT Query Preferences",
            value: "FRTResults"
          },
          {
            name: "FRT Shipments",
            value: "FRTShipments"
          }
        ];
        break;
      case 4:
        break;
    }
  }
  screenNameChange($event){
    this.screenName = $event.target.value;
    this.showBody = true;
  }
  
  ngOnDestroy(){
    this.observer$.unsubscribe();
  }
}
